import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Main from '../pages/Main';
import Delivery from '../pages/Delivery';
import Calculate from '../pages/Calculate';
import Setting from '../pages/Setting';
import ScrollToTop from './util/ScrollToTop';

export default class Content extends Component {
  render() {
    return (
      <ScrollToTop>
        <Switch>
          <>
            <div className="content-body">
              <Route exact path="/Delivery" component={Delivery} />
              <Route
                exact
                path="/Main"
                component={() => <Main setMain={this.props.setMain} />}
              />
              <Route exact path="/Calculate" component={Calculate} />
              <Route exact path="/Setting" component={Setting} />
            </div>
          </>
        </Switch>
      </ScrollToTop>
    );
  }
}
